import { createElement } from 'react';
import '../uniqueId.js';
import { shape } from 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends, a as _objectSpread } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import _omit from 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import '../Text/styled.js';
import '../Text/index.js';
import { formikField, reduxFormField } from '../adaptors/fields.js';
import 'reakit/Label';
import 'reakit/Input';
import '../chunk-2cd0d082.js';
import 'reakit/Hidden';
import '../Hidden/HiddenContainer.js';
import '../Hidden/styled.js';
import '../Hidden/HiddenShow.js';
import '../Hidden/HiddenHide.js';
import '../Hidden/HiddenToggle.js';
import '../Hidden/index.js';
import '../chunk-5c9bbccf.js';
import 'reakit/Popover';
import '../Popover/PopoverContainer.js';
import '../Popover/styled.js';
import '../Popover/PopoverHide.js';
import '../Popover/PopoverClose.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Popover/PopoverPopover.js';
import '../Popover/PopoverShow.js';
import '../Popover/PopoverToggle.js';
import '../chunk-8dd1e1d3.js';
import { a as FieldWrapper, b as fieldWrapperPropTypes, c as fieldWrapperDefaultProps } from '../chunk-1195bf9a.js';
import 'reakit/Field';
import '../Label/styled.js';
import '../Label/index.js';
import '../FieldWrapper/styled.js';
import './styled.js';
import { a as RadioGroup, b as radioGroupPropTypes, c as radioGroupDefaultProps } from './RadioGroup-aaadbeea.js';

var RadioGroupField = function RadioGroupField(_ref) {
  var a11yId = _ref.a11yId,
      a11yLabel = _ref.a11yLabel,
      className = _ref.className,
      defaultValue = _ref.defaultValue,
      description = _ref.description,
      disabled = _ref.disabled,
      hint = _ref.hint,
      isHorizontal = _ref.isHorizontal,
      isOptional = _ref.isOptional,
      isRequired = _ref.isRequired,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      options = _ref.options,
      radioGroupProps = _ref.radioGroupProps,
      state = _ref.state,
      validationText = _ref.validationText,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yId", "a11yLabel", "className", "defaultValue", "description", "disabled", "hint", "isHorizontal", "isOptional", "isRequired", "label", "name", "onChange", "options", "radioGroupProps", "state", "validationText", "value"]);

  return createElement(FieldWrapper, _extends({
    a11yId: a11yId,
    description: description,
    hint: hint,
    isOptional: isOptional,
    isRequired: isRequired,
    label: label,
    state: state,
    validationText: validationText
  }, props), function (_ref2) {
    var elementProps = _ref2.elementProps;
    return createElement(RadioGroup, _extends({
      a11yId: a11yId,
      a11yLabel: a11yLabel,
      className: className,
      defaultValue: defaultValue,
      disabled: disabled,
      isHorizontal: isHorizontal,
      name: name,
      options: options,
      state: state,
      value: value,
      onChange: onChange
    }, elementProps, radioGroupProps));
  });
};
RadioGroupField.Formik = formikField(RadioGroupField, {
  hasFieldWrapper: true
});
RadioGroupField.ReduxForm = reduxFormField(RadioGroupField, {
  hasFieldWrapper: true
});
var radioGroupFieldPropTypes = _objectSpread({
  radioGroupProps: shape(_omit(radioGroupPropTypes, 'options', 'name'))
}, _omit(fieldWrapperPropTypes, 'children'), radioGroupPropTypes);
RadioGroupField.propTypes = radioGroupFieldPropTypes;
var radioGroupFieldDefaultProps = _objectSpread({
  radioGroupProps: {}
}, fieldWrapperDefaultProps, radioGroupDefaultProps);
RadioGroupField.defaultProps = radioGroupFieldDefaultProps; // @ts-ignore

var C = RadioGroupField;

export default C;
export { RadioGroupField, radioGroupFieldDefaultProps, radioGroupFieldPropTypes };
